/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Messaging_Bots_Work_0_Metric_1_LabelInputs */

const en_svc_messaging_bots_work_0_metric_1_label = /** @type {(inputs: Svc_Messaging_Bots_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sync reliability`)
};

const ar_svc_messaging_bots_work_0_metric_1_label = /** @type {(inputs: Svc_Messaging_Bots_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`موثوقية المزامنة`)
};

const bn_svc_messaging_bots_work_0_metric_1_label = /** @type {(inputs: Svc_Messaging_Bots_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সিঙ্ক নির্ভরযোগ্যতা`)
};

const de_svc_messaging_bots_work_0_metric_1_label = /** @type {(inputs: Svc_Messaging_Bots_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronisierungszuverlässigkeit`)
};

const es_svc_messaging_bots_work_0_metric_1_label = /** @type {(inputs: Svc_Messaging_Bots_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiabilidad de sincronización`)
};

const fr_svc_messaging_bots_work_0_metric_1_label = /** @type {(inputs: Svc_Messaging_Bots_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiabilité de la synchronisation`)
};

const pt_svc_messaging_bots_work_0_metric_1_label = /** @type {(inputs: Svc_Messaging_Bots_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confiabilidade de sincronização`)
};

const zh_svc_messaging_bots_work_0_metric_1_label = /** @type {(inputs: Svc_Messaging_Bots_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同步可靠性`)
};

const tr_svc_messaging_bots_work_0_metric_1_label = /** @type {(inputs: Svc_Messaging_Bots_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senkronizasyon güvenilirliği`)
};

const ru_svc_messaging_bots_work_0_metric_1_label = /** @type {(inputs: Svc_Messaging_Bots_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Надежность синхронизации`)
};

const pl_svc_messaging_bots_work_0_metric_1_label = /** @type {(inputs: Svc_Messaging_Bots_Work_0_Metric_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niezawodność synchronizacji`)
};

/**
* | output |
* | --- |
* | "Sync reliability" |
*
* @param {Svc_Messaging_Bots_Work_0_Metric_1_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_messaging_bots_work_0_metric_1_label = /** @type {((inputs?: Svc_Messaging_Bots_Work_0_Metric_1_LabelInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Messaging_Bots_Work_0_Metric_1_LabelInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_messaging_bots_work_0_metric_1_label(inputs)
	if (locale === "bn") return bn_svc_messaging_bots_work_0_metric_1_label(inputs)
	if (locale === "de") return de_svc_messaging_bots_work_0_metric_1_label(inputs)
	if (locale === "es") return es_svc_messaging_bots_work_0_metric_1_label(inputs)
	if (locale === "fr") return fr_svc_messaging_bots_work_0_metric_1_label(inputs)
	if (locale === "pt") return pt_svc_messaging_bots_work_0_metric_1_label(inputs)
	if (locale === "zh") return zh_svc_messaging_bots_work_0_metric_1_label(inputs)
	if (locale === "tr") return tr_svc_messaging_bots_work_0_metric_1_label(inputs)
	if (locale === "ru") return ru_svc_messaging_bots_work_0_metric_1_label(inputs)
	if (locale === "pl") return pl_svc_messaging_bots_work_0_metric_1_label(inputs)
	return en_svc_messaging_bots_work_0_metric_1_label(inputs)
});
export { svc_messaging_bots_work_0_metric_1_label as "svc_messaging-bots_work_0_metric_1_label" }